// utils/request.js
import axios from 'axios'
import { Message, Loading } from 'element-ui'
import router from '@/router'
import { baseURL } from '@/utils/config.js'

const service = axios.create({
  baseURL,
  timeout: 80000
})

let loadingInstance = null
let requestCount = 0

const showLoading = () => {
  if (requestCount === 0) {
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  requestCount++
}

const hideLoading = () => {
  requestCount--
  if (requestCount <= 0) {
    requestCount = 0
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  }
}

service.interceptors.request.use(
  (config) => {
    showLoading()
    const token = localStorage.getItem('crm_token')
    if (token) {
      config.headers['Authorization'] = `${JSON.parse(token)}`
    }
    return config
  },
  (error) => {
    hideLoading()
    return Promise.reject(error)
  }
)

//  响应拦截器：根据 config.isDownload 判断是否特殊处理
service.interceptors.response.use(
  async (response) => {
    hideLoading()

    // 如果是下载请求，特殊处理
    if (response.config.isDownload) {
      const contentType = response.headers['content-type']

      // 如果是 JSON，说明是错误信息
      if (contentType && contentType.includes('application/json')) {
        const text = await response.data.text() // Blob → text
        let json
        try {
          json = JSON.parse(text)
        } catch (e) {
          Message.error('解析错误信息失败')
          return Promise.reject(new Error('解析失败'))
        }

        if (json.code !== 200) {
          Message.error(json.msg || '操作失败')
          return Promise.reject(new Error(json.msg || '下载失败'))
        }
      }

      // 是文件流，不处理，直接返回原始 response（供调用方下载）
      return response // 注意：这里返回的是完整 response，不是 response.data！
    }

    // 普通请求：走原来逻辑
    const { code } = response.data
    if (code === 401) {
      localStorage.removeItem('crm_token')
      setTimeout(() => {
        router.push('/login')
      }, 600)
    }
    return response.data
  },
  (error) => {
    hideLoading()
    if (error.response?.status === 401) {
      localStorage.removeItem('crm_token')
      setTimeout(() => {
        router.push('/login')
      }, 600)
    }
    Message({
      message: error.response?.data?.msg || error.message || '请求失败',
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service
